// Banner copy for a run that failed outside the SSE stream — the request never
// got far enough to send events, so there is no RunErrorEvent to show.
//
// The server authors user-facing wording in `detail` (a run already in flight, a
// refused HITL answer, a message with no text, a conversation that needs
// recreating), and its phrasing wins on whatever status carries it. Everything
// else is a transport failure whose raw text — `HTTP 502: <html>…`, "Failed to
// fetch" — names nothing the user can act on, so advice replaces it and the
// original goes to the console for diagnosis.
const TRANSIENT = "Something went wrong. Try again in a moment.";

export function runErrorMessage(error: unknown): string {
  if (typeof error !== "object" || error === null) return TRANSIENT;
  const { detail } = ((error as { payload?: unknown }).payload ?? {}) as { detail?: unknown };
  return typeof detail === "string" && detail.trim() ? detail : TRANSIENT;
}
